const titles: { [key: string]: string } = {
  "232.1": "Ute",
  "189.0": "Ute",
  "37.2": "Bad",
  "61.1": "Stue",
};

export default titles;
